import { OTP_ERROR_INCOMPLETE } from '@/components/OtpEntry/constants'

// Constants
export { OTP_LENGTH } from '@/components/OtpEntry/constants'
export const DEFAULT_EXPIRES_IN = 300
export const DEFAULT_CAN_RESEND_AFTER = 60
export const BRAND_COLOR = '#0ABF89'

// Error messages
export const ERROR_MESSAGES = {
  INCOMPLETE_OTP: OTP_ERROR_INCOMPLETE,
  MISSING_EMAIL: 'Email address is missing. Please start over.',
  INCORRECT_OTP: 'Incorrect OTP. Please try again.',
  RESEND_FAILED: 'Failed to resend OTP. Please try again.'
}

// Success messages
export const SUCCESS_MESSAGES = {
  EMAIL_VERIFIED: 'Email verified successfully!',
  OTP_RESENT: 'OTP resent successfully!'
}
